import {
  type ValidatorFunction,
  type ValidatorResult,
} from 'ember-changeset-validations';
import { utcDate, isSameOrBefore } from 'uplisting-frontend/utils/date';

export function validateIsSameOrBefore(fieldName: string): ValidatorFunction {
  return (
    _key: string,
    newValue: unknown,
    _oldValue: unknown,
    changes: Record<string, unknown>,
    content: Record<string, unknown>,
  ): ValidatorResult => {
    const other = (changes[fieldName] ?? content[fieldName]) as Date;

    return isSameOrBefore(newValue as Date, other ?? utcDate(new Date()));
  };
}
